import gqlTag from 'graphql-tag';
import { gql } from 'types/__generated__/gql';
import { Base_Classroom_FragmentFragmentDoc as BASE_CLASSROOM_FRAGMENT } from 'types/schema-generated-types';
import ORGANIZATION_FRAGMENT from './organization';

// TODO: Including both variants here until we have time to consolidate.
export const KEYBOARDING_STUDENT_EXPORT_FRAGMENT_LEGACY = gqlTag`
  fragment BaseKeyboardingStudentExportLegacy on KeyClassroomEngagementReportResult {
    assessmentAccelerator {
      averageAttemptCount
      averageFirstAttemptCount
      averageSecondsSpent
      activityTypes {
        activityType {
          id
          name
        }
        modules {
          moduleIds
          averageAttemptCount
          averageSecondsSpent
        }
      }
    }
    students {
      student {
        id
        firstName
        lastName
        gradeLevel
        sisId
        organization {
          ...BaseOrganization
          rootOrganization {
            name
            id
          }
        }
        classrooms {
          sisId
          ...BASE_CLASSROOM_FRAGMENT
        }
      }
      productCurriculumCode
      lastLoginDate
      curriculumWeek
      curriculumProgressPercentage
      totalActivitiesCompletedCount
      averageWeeklyMinutesSpent
      spotChecks {
        totalCompletedCount
        dateLastCompleted
        averageWpm
        averageAccuracy
        activities {
          template
          dateCompleted
          week
          wpm
          accuracy
        }
      }
      scheduledActivities {
        assessmentCompletedCount
        assessmentSkippedCount
        assessmentAverageWpm
        assessmentAverageAccuracy
        activities {
          dateCompleted
          wpm
          accuracy
        }
      }
      teacherCreatedActivities {
        totalCompletedCount
        averageWpm
        averageAccuracy
      }
      enrichmentActivities {
        hearItTypeItCompletedCount
        myChoiceKeyboardingCompletedCount
      }
    }
  }
  ${BASE_CLASSROOM_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
`;

const KEYBOARDING_STUDENT_EXPORT_FRAGMENT = gql(/* GraphQL */ `
  fragment BaseKeyboardingStudentExport on KeyClassroomEngagementReportResult {
    assessmentAccelerator {
      averageAttemptCount
      averageFirstAttemptCount
      averageSecondsSpent
      activityTypes {
        activityType {
          id
          name
        }
        modules {
          moduleIds
          averageAttemptCount
          averageSecondsSpent
        }
      }
    }
    students {
      student {
        id
        firstName
        lastName
        gradeLevel
        sisId
        organization {
          id
          sisId
          name
          type
          parentOrganizationId
          rootOrganization {
            name
            id
          }
        }
        classrooms {
          id
          sisId
          name
          users {
            userId
            user {
              firstName
              lastName
            }
            classroomRoles {
              name
              displayName
              classification
            }
          }
        }
      }
      productCurriculumCode
      lastLoginDate
      curriculumWeek
      curriculumProgressPercentage
      totalActivitiesCompletedCount
      averageWeeklyMinutesSpent
      spotChecks {
        totalCompletedCount
        dateLastCompleted
        averageWpm
        averageAccuracy
        activities {
          template
          dateCompleted
          week
          wpm
          accuracy
        }
      }
      scheduledActivities {
        assessmentCompletedCount
        assessmentSkippedCount
        assessmentAverageWpm
        assessmentAverageAccuracy
        activities {
          dateCompleted
          wpm
          accuracy
        }
      }
      teacherCreatedActivities {
        totalCompletedCount
        averageWpm
        averageAccuracy
      }
      enrichmentActivities {
        hearItTypeItCompletedCount
        myChoiceKeyboardingCompletedCount
      }
    }
  }
`);

export default KEYBOARDING_STUDENT_EXPORT_FRAGMENT;
